/**
 * 医生班次段模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取班次列表
export const shiftList = (params) => {
  return req.get('/scheduling/time/list', params);
}

// 新增班次
export const shiftAdd = (params) => {
  return req.post('/scheduling/time', params);
}
// 修改班次
export const shiftEdit = (params) => {
  return req.put('/scheduling/time', params);
}

// 删除班次信息
export const shiftDelete = (timeIds) => {
  return req.post(`/scheduling/time/remove`, { schedulingItemId: timeIds });
}
